import { HelpContentContainer } from ".";
import { ModalHeader } from "@/components/Modal/ModalHeader";
import { AppText } from "@/components/Text/AppText";
import { translate } from "@/helper/translate";

interface HelpGuideStylingProps {
    onClose: () => void;
}

export const HelpGuideStyling = ({ onClose }: HelpGuideStylingProps) => {
    return (
        <>
            <ModalHeader
                title="Styling your Resume"
                onClose={onClose}
            />
            <HelpContentContainer>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    We make it easy for you to style your resume. To do so,
                    select the paintbrush icon (insert paintbrush icon here) in
                    the sidebar and choose from the following:
                </AppText>
                <ul>
                    <li>
                        <AppText
                            variant="regular"
                            className="mb-2"
                        >
                            <strong>Layout:</strong> Change from full page to
                            split page layout
                        </AppText>
                    </li>
                    <li>
                        <AppText
                            variant="regular"
                            className="mb-2"
                        >
                            <strong>Font:</strong> Change the font type for the
                            resume
                        </AppText>
                    </li>
                    <li>
                        <AppText
                            variant="regular"
                            className="mb-2"
                        >
                            <strong>Font Size:</strong> Change the document
                            level font sizing
                        </AppText>
                    </li>
                    <li>
                        <AppText
                            variant="regular"
                            className="mb-2"
                        >
                            <strong>
                                Accent {translate("colour", "title")}:
                            </strong>{" "}
                            Background {translate("colour", "title")} within the
                            header section and the theme colour for your titles
                        </AppText>
                    </li>
                    <li>
                        <AppText
                            variant="regular"
                            className="mb-2"
                        >
                            <strong>Show Icons:</strong> Toggle whether icons
                            will be displayed
                        </AppText>
                    </li>
                    <li>
                        <AppText
                            variant="regular"
                            className="mb-2"
                        >
                            <strong>Underline Heading:</strong> Toggle whether
                            to display an underline on section headings
                        </AppText>
                    </li>
                </ul>
            </HelpContentContainer>
        </>
    );
};
